export default "__VITE_ASSET__DXkpBkD2__"